export const SSR_INITIAL_DATA_ID = "ssr-initial-data";

/** Inert JSON is readable by the app bundle without permitting inline scripts. */
export function buildInitialDataScript(data: unknown): string {
  const json = JSON.stringify(data)
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/&/g, "\\u0026")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
  return `<script id="${SSR_INITIAL_DATA_ID}" type="application/json">${json}</script>`;
}
